import React, { useEffect, useState } from "react";
import IconBar from "./IconBar";
import QuestionText from "./QuestionText";
import Image from "../../components/common/Image";
import FlexBox from "../../components/common/FlexBox";
import { Box, Typography } from "@mui/material";

export default function Solution(props) {
  const solution = props.location.state.solution;
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  function getElements() {
    if (solution.length === 0) return <></>;

    const els = solution.map((x, i) => {
      if (
        x.text.toLowerCase().includes(".png") ||
        x.text.includes(".jpg") ||
        x.text.includes(".jpeg")
      ) {
        return (
          <div key={i} style={{ marginTop: "1em", textAlign: "center" }}>
            <Image src={x.text.replace("//uploads", "/uploads")} width={"250px"}></Image>
          </div>
        );
      }
      return (
        <div key={i}>
          <Typography
            variant="h6"
            style={{
              fontWeight: "bold",
              color: "#fbcd02",
              padding: "5px",
              textAlign: "left",
              marginBottom: "5px",
              fontSize: "1.1rem",
            }}
          >
            Solution for Question {(() => {
              try {
                const parsed = parseInt(props.location.state.question);
              return isNaN(parsed) ? "" : parsed + 1;
              } catch {
              return "";
              }
            })()}
          </Typography>
          <hr
            style={{
              marginBottom: "10px",
              borderColor: "#FBCD02",
              borderWidth: "1px",
              borderStyle: "solid",
              width: "100%",
            }}
          />
          <QuestionText question={x}></QuestionText>
        </div>
      );
    });
    return els;
  }
  return (
    <>
      {" "}
      <Box
        style={{ height: "100%", width: windowWidth >= 800 ? "50%" : "90%" }}
      >
        <div className="HeaderBox">
          <IconBar location="solution"></IconBar>
        </div>
        <div
          style={{
            fontSize: "0.9rem",
            backgroundColor: "rgb(33, 42, 65)",
            padding: "10px",
            paddingBottom: "15px",
            borderRadius: "5px",
            fontWeight: "bold",
            textAlign: "center",
            alignItems: "center",
          }}
        >
          {getElements()}
        </div>
      </Box>
    </>
  );
}
